import { createContext, useContext } from "react";

export interface TipTapBlockEditorContext {
  addToLocalInlineAttachments?: (args: any) => void;
  addToLocalSgidToObjectMap?: (args: any) => void;
  aiCopilotTitle?: string;
  disableMentionClicks?: boolean;
  inlineAttachments?: any[];
  isWithinEmailEditor?: boolean;
  localInlineAttachments?: any[];
  localSgidToObjectMap?: any;
  sgidToObjectMap?: any;
  shouldPreviewFilesAsLinks?: boolean;
  spaceId?: number;
  type?: "block";
}

export const BlockEditorContext =
  createContext<TipTapBlockEditorContext | null>(null);
BlockEditorContext.displayName = "BlockEditorContext";

export const useBlockEditorContext = () => useContext(BlockEditorContext);
